















import Vue, { PropType } from 'vue'
import { DashboardTemplate } from '../../base/store/state.interface'
import BaseDialog from './BaseDialog.vue'

export default Vue.extend({
  components: {
    BaseDialog
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    template: {
      type: Object as PropType<DashboardTemplate>,
      required: false,
      default: undefined
    }
  },
  data() {
    return {
      layoutName: ''
    }
  },
  computed: {
    hasTemplate() {
      return this.template && this.template.id
    }
  },
  methods: {
    saveLayout() {
      this.$emit('saveDashboard', this.template ? this.template.id : undefined, this.layoutName)
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    onShowDialog() {
      this.layoutName = this.template ? this.template.title : ''
      window.setTimeout(() => this.$refs.inputField.focus(), 1)
    }
  }
})
